// extracted by mini-css-extract-plugin
export default {"site_footer":"Footer_site_footer__RoERz"};